import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import emptyKra from "../../../../img/empty.jpg";
import { useField } from "formik";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useSnackbar } from "notistack";
import {
  deleteAssignedByUserType,
  getAssignedKra,
} from "../../../../redux/features/appraisalSlice";
import ImportData from "../ImportData";
import TagWill from "./TagWill";
import WillLibrary from "./WillLibrary";

const WillLanding = ({}) => {
  const dispatch = useDispatch();
  const [selectedHeader, setselectedHeader] = useState("1");
  const { enqueueSnackbar } = useSnackbar();

  const { loading, taggedKra } = useSelector((state) => state.appraisal);

  const data = {
    type: "will",
  };

  useEffect(() => {
    dispatch(getAssignedKra(data));
  }, []);

  const handleDelete = (tag) => {
    dispatch(
      deleteAssignedByUserType({
        usertypeId: tag?.usertypeDetails?.userTypeId,
        type: "will",
      })
    ).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        dispatch(getAssignedKra(data));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
        // setOpen(false);
      }
    });
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          padding: 1,
          mb: 2,
        }}
      >
        <Box sx={{ width: "200px" }}>
          {/* <FormControl>
            <Select
              value={selectedHeader}
              onChange={handleHeader}
              sx={{
                width: "250px",
                mb: 1,
              }}
              size="small"
            >
              {taggingData.map((header) => (
                <MenuItem key={header.tagging_id} value={header.tagging_id}>
                  {header.tagging_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Box>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          {taggedKra.length > 0 && <TagWill dispatchData={data} />}
          <WillLibrary />
          <ImportData tagImport={true} library={"will"} dispatchData={data} />
        </Stack>
      </Box>
      {taggedKra.length === 0 && (
        <Box
          sx={{
            width: "100%",
            padding: 2,
            boxShadow: " rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            borderRadius: 2,
            display: "flex",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={emptyKra}
            alt="Empty KRA"
            style={{ width: "20%", height: "auto", objectFit: "contain" }}
          />
          <Typography variant="h6" color="GrayText">
            No KRA have been tagged
          </Typography>
          <TagWill dispatchData={data} />
        </Box>
      )}
      <Box>
        {taggedKra.map((tag) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexDirection: "row",
              padding: 2,
              mb: 1,
              borderRadius: "8px",
              boxShadow: " rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Stack direction={"row"} spacing={1} mb={2}>
                <Button size="small" variant="outlined" color="secondary">
                  <Icon icon="tdesign:user-filled" width={18} height={18} />
                  {tag.usertypeDetails?.userType}
                </Button>
              </Stack>
              {tag.libraryDetails?.map((kra) => (
                <Stack direction={"row"} spacing={1} mb={1}>
                  <Chip
                    label={kra.weightage}
                    color="primary"
                    size="medium"
                    variant="outlined"
                    icon={
                      <Icon icon="fa-solid:percentage" width={18} height={18} />
                    }
                  />
                  <Chip
                    label={kra.libraryName}
                    color="primary"
                    size="medium"
                    variant="outlined"
                    icon={
                      <Icon
                        icon="fluent:tag-28-filled"
                        width={18}
                        height={18}
                      />
                    }
                  />
                </Stack>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
              }}
            >
              <TagWill
                key={tag?.usertypeDetails?.userTypeId}
                edit={true}
                editData={tag}
                dispatchData={data}
              />
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleDelete(tag)}
              >
                <Icon icon="mdi:delete" width={18} height={18} />
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default WillLanding;
